import urlJoin from './urlJoin';

export const buildUrl = (protocol: string, host: string, ...uris: (string | string[])[]) => {
  return urlJoin(`${ protocol }//${ host }`, ...uris);
};

export default buildUrl;
